export const PrintItemTHeadLayout = () => {
	return (
		<div className="grid grid-cols-12 font-semibold">
			<div className="col-span-2 border border-zinc-200 p-1" />
			<div className="col-span-6 border border-zinc-200 p-1">
				<p>名称</p>
			</div>
			<div className="col-span-2 border border-zinc-200 p-1">
				<p>料金</p>
			</div>
			<div className="col-span-2 border border-zinc-200 p-1">
				<p>お支払い金額</p>
			</div>
		</div>
	);
};
